import React from 'react';
import classNames from 'classnames';
import cls from './ModalBodyReconciliationOfCalculations.module.css';
import { useModalBodyReconciliationOfCalculations } from './useModalBodyReconciliationOfCalculations';
import { ModalBodyTableRegistry } from './ModalBodyTableRegistry/ModalBodyTableRegistry';
import { ModalBodyTableReconciliation } from './ModalBodyTableReconciliation/ModalBodyTableReconciliation';

interface ModalBodyReconciliationOfCalculationsProps {
    classes?: string;
}

export const ModalBodyReconciliationOfCalculations = ({
    classes,
}: ModalBodyReconciliationOfCalculationsProps) => {
    const { calculations, payments } = useModalBodyReconciliationOfCalculations();
    return (
        <div className={classNames(cls.ModalBodyReconciliationOfCalculations, [classes])}>
            <ModalBodyTableReconciliation calculationsInformation={calculations} />
            <ModalBodyTableRegistry paymentsInformation={payments} />
        </div>
    );
};
